import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "home"
};
const _hoisted_2 = {
  class: "headerActions"
};
const _hoisted_3 = {
  class: "el-dropdown-link"
};
const _hoisted_4 = {
  class: "avatarCirl"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  key: 1,
  class: "homeWelcome"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
  const _component_el_dropdown = _resolveComponent("el-dropdown");
  const _component_el_header = _resolveComponent("el-header");
  const _component_el_menu_item = _resolveComponent("el-menu-item");
  const _component_el_sub_menu = _resolveComponent("el-sub-menu");
  const _component_el_menu = _resolveComponent("el-menu");
  const _component_el_aside = _resolveComponent("el-aside");
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb");
  const _component_router_view = _resolveComponent("router-view");
  const _component_el_main = _resolveComponent("el-main");
  const _component_el_container = _resolveComponent("el-container");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, {
    class: "homeRoot"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_header, {
      class: "homeHeader",
      height: "60px"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_icon, {
        class: "menuToggle",
        onClick: _cache[0] || (_cache[0] = $event => $setup.menuOpen = !$setup.menuOpen)
      }, {
        default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent($setup.menuOpen ? 'Expand' : 'Fold')))]),
        _: 1
      }), _cache[5] || (_cache[5] = _createElementVNode("div", {
        class: "title"
      }, "招聘管理系统", -1)), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
        icon: _ctx.Bell,
        text: "",
        size: "normal",
        class: "headerIcon",
        onClick: $setup.goSettings
      }, null, 8, ["icon", "onClick"]), _createVNode(_component_el_dropdown, {
        class: "userInfo",
        onCommand: $setup.handleCommand
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
            command: "profile"
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("个人中心", -1)]))]),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            command: "settings"
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode("设置", -1)]))]),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            command: "logout",
            divided: ""
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("注销登录", -1)]))]),
            _: 1
          })]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("span", _hoisted_3, [_createTextVNode(_toDisplayString($setup.userInfo.real_name || $setup.userInfo.username) + " ", 1), _createElementVNode("i", _hoisted_4, [_createElementVNode("img", {
          src: $setup.userAvatar,
          alt: "用户头像"
        }, null, 8, _hoisted_5)])])]),
        _: 1
      }, 8, ["onCommand"])])]),
      _: 1
    }), _createVNode(_component_el_container, {
      class: "homeBody"
    }, {
      default: _withCtx(() => [_createVNode(_Transition, {
        name: "fade"
      }, {
        default: _withCtx(() => [$setup.menuOpen && $setup.isMobile ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "sideMask",
          onClick: _cache[1] || (_cache[1] = $event => $setup.menuOpen = false)
        })) : _createCommentVNode("", true)]),
        _: 1
      }), _createVNode(_component_el_aside, {
        width: "200px",
        class: _normalizeClass(["homeAside", {
          mobileOpen: $setup.menuOpen
        }])
      }, {
        default: _withCtx(() => [_createVNode(_component_el_menu, {
          router: "",
          "unique-opened": "",
          "default-active": $setup.activeMenu,
          class: "homeMenu"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.menuGroups, (group, index) => {
            return _openBlock(), _createBlock(_component_el_sub_menu, {
              index: $setup.groupIndex(group),
              key: index
            }, {
              title: _withCtx(() => [_createElementVNode("i", {
                style: {
                  "color": "#409eff",
                  "margin-right": "5px"
                },
                class: _normalizeClass($setup.groupIconClass(group.groupIcon))
              }, null, 2), _createElementVNode("span", null, _toDisplayString(group.title), 1)]),
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.children, child => {
                return _openBlock(), _createBlock(_component_el_menu_item, {
                  index: $setup.menuIndex(child.path),
                  key: child.path
                }, {
                  default: _withCtx(() => [child.icon ? (_openBlock(), _createBlock(_component_el_icon, {
                    key: 0
                  }, {
                    default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(child.icon)))]),
                    _: 2
                  }, 1024)) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(child.title), 1)]),
                  _: 2
                }, 1032, ["index"]);
              }), 128))]),
              _: 2
            }, 1032, ["index"]);
          }), 128))]),
          _: 1
        }, 8, ["default-active"])]),
        _: 1
      }, 8, ["class"]), _createVNode(_component_el_main, {
        class: "homeMain"
      }, {
        default: _withCtx(() => [$setup.route.path !== '/dashboard' ? (_openBlock(), _createBlock(_component_el_breadcrumb, {
          key: 0,
          separator: "/",
          class: "homeBreadcrumb"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_breadcrumb_item, {
            to: {
              path: '/dashboard'
            }
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("首页", -1)]))]),
            _: 1
          }), _createVNode(_component_el_breadcrumb_item, null, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.currentRouteTitle), 1)]),
            _: 1
          })]),
          _: 1
        })) : _createCommentVNode("", true), $setup.route.path === '/dashboard' ? (_openBlock(), _createElementBlock("div", _hoisted_6, " 欢迎来到招聘管理系统！ ")) : _createCommentVNode("", true), _createVNode(_component_router_view, {
          class: "homeRouterView"
        })]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  })]);
}